module.exports = __webpack_public_path__ + "static/staff@large-6fbbf54e626116c56ee4ab1d9f983c2c.jpg";